import { render, staticRenderFns } from "./FullWithCard.vue?vue&type=template&id=2b779cb6&"
import script from "./FullWithCard.js?vue&type=script&lang=js&"
export * from "./FullWithCard.js?vue&type=script&lang=js&"
import style0 from "./FullWithCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VOverlay,VProgressCircular,VRow})
